import { useDialog } from "@shared/features/dialog/useDialog";
import { useProgram } from "../../hooks/useProgram";
import { FriendInvitationFormDialog } from "../../../friendInvitation/components/FriendInvitationFormDialog/FriendInvitationFormDialog";
import { useGetUserData } from "@platform/hooks/useGetUserData";

export function ProgramFriendInviteFormContainer() {
  const { activeDialog, closeDialog } = useDialog();

  const isOpen = activeDialog === "invitationSend";

  const { program } = useProgram();

  const { refetch: refetchUserData } = useGetUserData();

  if (!program) return null;

  const handleDone = async () => {
    // refetch user data
    await refetchUserData();

    // close the dialog
    closeDialog("invitationSend");
  };

  return (
    <FriendInvitationFormDialog
      onDone={handleDone}
      onClose={handleDone}
      isOpen={isOpen}
      programId={parseInt(program.id, 10)}
    />
  );
}

export default ProgramFriendInviteFormContainer;
